$(document).on('click', '.pledge-results-make-pledge-btn', function() {
  /** Set the cookie */
  var id = $(this).attr('data-id'),
    url = $(this).attr('data-login');

  setCookie('pledge_redirect_id', id, 7);

  /** Then redirect them to the login page */
  window.location.href = url;
});